const testimonials = [
  {
    name: "Chad B.",
    location: "Thibodaux, LA — Offshore Driller",
    rating: 5,
    text: "I got international rotation papers for Angola with 14 days notice. My passport had been expired for over a year — I had been on domestic Gulf platforms for the last two years and just never renewed it. Fast Passport Center got me an emergency renewal in 5 business days. I made my flight to Lagos on schedule. Without these guys I would have lost the rotation and probably the contract. They are essential for anyone in the oilfield.",
    service: "Emergency Renewal — Offshore Rotation",
  },
  {
    name: "Prof. Michelle A.",
    location: "Thibodaux, LA — Nicholls State Faculty",
    rating: 5,
    text: "I was presenting research at an academic conference in Seville and discovered my passport had expired when I was booking my flights — six weeks before departure. I assumed I would have to withdraw from the program. Fast Passport Center processed my renewal in eight days. I presented my paper, the conference was excellent, and I was back at NSU the following Monday. Genuinely saved my professional presentation.",
    service: "Expedited Renewal — Academic Conference",
  },
  {
    name: "Bobby & Marie L.",
    location: "Raceland, LA",
    rating: 5,
    text: "We booked a Caribbean cruise out of New Orleans on a promotional deal — best price we had ever seen. Two weeks later we found out our youngest son's passport from his school trip five years ago had expired. He was 15 and we needed a child renewal fast. Fast Passport Center guided us through the process, we went to the Thibodaux acceptance facility, shipped everything overnight, and his passport arrived in 7 days. We sailed as a complete family.",
    service: "Child Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ThibodauxTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Thibodaux &amp; Lafourche Parish Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real stories from Thibodaux offshore workers, NSU faculty, and Raceland families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}